"use client";
import Image from "next/image";
import { usePathname, useSearchParams } from "next/navigation";
import { authPlaceholder, registerIndividualPlaceholder, registerOrganizationPlaceholder } from "@assets";

const AuthPlacholder = () => {
	const path = usePathname();
	const searchParams = useSearchParams();
	const type = searchParams.get("type") ?? "";

	if (path === "/auth/register") {
		if (type === "INDIVIDUAL") {
			return (
				<section className="sticky inset-y-0 left-0 hidden max-h-screen w-1/3 xl:block">
					<Image alt="register-individual-placeholder" className="h-screen w-full object-cover" priority src={registerIndividualPlaceholder} />
				</section>
			);
		} else if (type === "ORGANIZATION") {
			return (
				<section className="sticky inset-y-0 left-0 hidden max-h-screen w-1/3 xl:block">
					<Image alt="register-organization-placeholder" className="h-screen w-full object-cover" priority src={registerOrganizationPlaceholder} />
				</section>
			);
		}
	} else {
		return (
			<section className="sticky inset-y-0 left-0 hidden max-h-screen w-1/3 xl:block">
				<Image alt="auth-placeholder" className="h-screen w-full object-cover" priority src={authPlaceholder} />
			</section>
		);
	}
};

export default AuthPlacholder;
